import { type Change } from "@redotech/redo-model/team-settings-audit";
import { memo } from "react";
import * as styles from "./team-changes-tooltip.module.css";

interface TeamChangesTooltipProps {
  changes: Change[];
}

export const TeamChangesTooltip = memo(function TeamChangesTooltip(
  props: TeamChangesTooltipProps,
) {
  const { changes } = props;

  if (!changes || changes.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.changesHeader}>Settings changed</div>
      <div className={styles.changesList}>
        {changes.map((change, index) => (
          <div className={styles.changeItem} key={index}>
            <div className={styles.pathLabel}>{change.path}</div>
            <div className={styles.valuesContainer}>
              <textarea
                className={styles.value}
                readOnly
                value={formatValue(change.prev)}
              />
              <span className={styles.arrow}>→</span>
              <textarea
                className={styles.value}
                readOnly
                value={formatValue(change.next)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

function formatValue(value: any): string {
  if (value === null) return "null";
  if (value === undefined) return "undefined";
  if (value === "") return '""';
  if (typeof value === "boolean") return value ? "true" : "false";
  if (typeof value === "object") {
    if (Array.isArray(value)) {
      return `[${value.length} items]`;
    }
    if (value instanceof Date) {
      return value.toISOString();
    }
    return JSON.stringify(value);
  }
  return String(value);
}
